import React, { useContext, useState } from 'react';
import * as S from './TabelaValorizacaoStyle';
import { formatDateFromUTC, formatNumber } from '../../assets/utils';
import { FiX, FiCalendar, FiTrendingUp, FiChevronsUp, FiDollarSign, FiFileText } from 'react-icons/fi';
import { AuthContext } from '../../context/AuthContext';

const TabelaValorizacao = ({ historico, currentPage, totalPages, onPageChange }) => {
    const [modalData, setModalData] = useState(null);
    const {contracts} = useContext(AuthContext)

    const handleContractIncrementAmount = (contractId, contractIncrement) => {
        if (contracts) {
            // Buscamos o contrato específico na lista
            const found = contracts.find(c => c.contract.id === contractId);
            
            if (found) {
                const amount = found.contract.totalPrice * (contractIncrement / 100);
                return `R$ ${formatNumber(amount)}`;
            }
        }
        return "Não encontrado";
    }

    
    return (
        <>
            <S.TableWrapper>
                <S.Table>
                    <thead>
                        <tr>
                            <th>Data</th>
                            <th>Contrato</th>
                            <th>Valorização Diária (%)</th>
                            <th>Valorização Diária (R$)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historico.length > 0 ? (
                            historico.map((item, index) => (
                                <tr key={`${item.contractId}-${item.valorizationDate}-${index}`} onClick={() => setModalData(item)}>
                                    <td>{formatDateFromUTC(item.valorizationDate)}</td>
                                    <td>#{item.contractId}</td>
                                    <td>+{formatNumber(item.dailyIncrement)}%</td>
                                    <td>{handleContractIncrementAmount(item.contractId, item.dailyIncrement)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5">Nenhum registro encontrado para os filtros selecionados.</td>
                            </tr>
                        )}
                    </tbody>
                </S.Table>
            </S.TableWrapper>

            {totalPages > 1 && (
                 <S.Pagination>
                    <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>Anterior</button>
                    <span>Página {currentPage} de {totalPages}</span>
                    <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages}>Próxima</button>
                </S.Pagination>
            )}

            {modalData && (
                <S.ModalOverlay onClick={() => setModalData(null)}>
                    <S.ModalContent onClick={e => e.stopPropagation()}>
                        <S.ModalHeader>
                            <h2>Detalhes da Valorização</h2>
                            <S.CloseButton onClick={() => setModalData(null)}><FiX /></S.CloseButton>
                        </S.ModalHeader>
                        <S.ModalBody>
                            <S.ModalInfo>
                                <span><FiCalendar/> Data</span>
                                <p>{formatDateFromUTC(modalData.valorizationDate)}</p>
                            </S.ModalInfo>
                             <S.ModalInfo>
                                <span><FiFileText/> Contrato</span>
                                <p>#{modalData.contractId}</p>
                            </S.ModalInfo>
                             <S.ModalInfo>
                                <span><FiTrendingUp/> Saldo Anterior</span>
                                <p>{formatNumber(modalData.previousValue)}%</p>
                            </S.ModalInfo>
                             <S.ModalInfo>
                                <span><FiChevronsUp/> Rendimento do Dia</span>
                                <p>+{formatNumber(modalData.dailyIncrement)}%</p>
                            </S.ModalInfo>
                             <S.ModalInfo highlight>
                                <span><FiDollarSign/> Novo Saldo</span>
                                <p>{formatNumber(modalData.newValue)}%</p>
                            </S.ModalInfo>
                        </S.ModalBody>
                    </S.ModalContent>
                </S.ModalOverlay>
            )}
        </>
    );
}

export default TabelaValorizacao;